import { createContext } from 'react';
import { ProjectMembers } from '../api/project';

export const DEFAULT_SQUAD: ProjectMembers = {
  users: [],
  teams: [],
  members: [],
};

export const SquadContext = createContext<ProjectMembers>(DEFAULT_SQUAD);
